import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterDirectoryItem_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search icon i-auto-complete i-article-a" id="directoryFilter">
                      <input autocomplete='off' data-bind=" value: $parent.selectedDirectoryItemArticleTitle() , event: { keyup: onChangeInput }, valueUpdate : 'afterkeydown'" id="dirItemTitleInput" list="articles" class="input-text" placeholder = "Article"><!--  -->
                          <ul class="form-auto-list" data-bind="foreach: articles, visible: isShowArticleSuggestions" id="articles_directory_item">
                            <!-- ko ifnot: $parent.showDetails() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.title, click: $parent.onBlurArticle" ></li>
                            <!-- /ko -->

                            <!-- ko if: $parent.showDetails() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, click: $parent.onBlurArticle">
                                <span class="title" data-bind="text: $data.title"></span>
                                <span class="date">ID:
                                    <span data-bind="text: $data.id ?? ''"></span>
                                </span>
                                <span class="date">Last Published:
                                <span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                                </span>
                            </li>
                            <!-- /ko -->
                          </ul>
                      </input>
                     <button data-bind="attr: { id: 'user-input-close_' + elementIdentifier() }, event: { click: onClearInput }" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterDirectoryItem-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let that = this;
        return {
            articles: ko.observableArray([])
            , idArticle: ko.observable(null)
            , article: ko.observable("")
            , articleObj: ko.observable(null)
            , placeholder: ko.observable("Article")
            , isShowArticleSuggestions: ko.observable(false)
            , elementIdentifier: ko.observable(this.idElement)
            , showDetails: ko.observable(false)
            , onChangeInput: function (data, event) { that.onChangeInput(data, event);}
            , onClearInput: function (data, event) { that.onClearInput(event);}
            , onChangeFilterAction: function (data, event) { that.onChangeFilterAction(data) }
            , onBlurArticle: function (value, data, event) { that.onBlurArticle(value, data, event); }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected onChangeInput(data, event) {
        let input = event.target;
        let inputWrapper = input.parentNode;

        let closeBtn = inputWrapper.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());

        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }
        this.onChangeArticleDataListArticle(event, this.viewModel[this.idElement].idArticle);
    }

    protected onChangeArticleDataListArticle(event, idArticle) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("articles").childNodes;
        if (inputVal.length >= 3) {

            this.caller.getArticlesSuggestion(inputVal, this.viewModel.activeDirectory());
            this.getTemplateViewModel().isShowArticleSuggestions(true);
        }else {

            this.getTemplateViewModel().isShowArticleSuggestions(false);
        }

        if (inputVal.length == 0) {

            let closeBtn = document.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());

            this.resetArticle();

            if (closeBtn.classList.contains('is-showing')) {

                closeBtn.classList.remove('is-showing');
            }
            this.caller.filterSimpleOnChange(this.idElement);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idArticle(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    public onClearInput(event) {

        this.resetArticle();
        if (event )
        {
            let button = event.target;

            if (button && button.classList.contains('is-showing')) {

                button.classList.remove('is-showing');

                this.caller.filterSimpleOnChange(this.idElement);
            }
        }
    }

    public resetArticle() {

        this.getTemplateViewModel().article("");
        this.getTemplateViewModel().articles([]);
        this.getTemplateViewModel().articleObj(null);
        this.getTemplateViewModel().idArticle(null);
        this.getTemplateViewModel().isShowArticleSuggestions(false);

        document.querySelectorAll("#dirItemTitleInput").forEach(function(input) {
            input.nodeValue = "";
        });

        if(this.viewModel.activeDirectory() == 'sandbox_directory') {

            this.caller.articlesEdit.sandboxDirectory.resetSelectedArticle();
        }else {
            this.caller.articlesEdit.articleDirectory.resetSelectedArticle();
        }
    }

    protected onBlurArticle(value, data, event) {

        if(this.viewModel.activeDirectory() == 'sandbox_directory'){

            this.caller.articlesEdit.sandboxDirectory.getTemplateViewModel().selectedDirectoryItemArticle(value)
            this.caller.articlesEdit.sandboxDirectory.getTemplateViewModel().selectedDirectoryItemArticleTitle(value.title)
            this.caller.articlesEdit.sandboxDirectory.getTemplateViewModel().selectedDirectoryItemIdArticle(value.id)

        }else if(this.viewModel.activeDirectory() == 'republish_directory'){

            this.caller.articlesEdit.republishDirectory.getTemplateViewModel().selectedDirectoryItemArticle(value)
            this.caller.articlesEdit.republishDirectory.getTemplateViewModel().selectedDirectoryItemArticleTitle(value.title)
            this.caller.articlesEdit.republishDirectory.getTemplateViewModel().selectedDirectoryItemIdArticle(value.id)

        }else{

            this.caller.articlesEdit.articleDirectory.getTemplateViewModel().selectedDirectoryItemArticle(value)
            this.caller.articlesEdit.articleDirectory.getTemplateViewModel().selectedDirectoryItemArticleTitle(value.title)
            this.caller.articlesEdit.articleDirectory.getTemplateViewModel().selectedDirectoryItemIdArticle(value.id)
        }

        if ( !value.hasOwnProperty("permalink") )
            value.permalink = null

        this.getTemplateViewModel().article(value.title);
        this.getTemplateViewModel().articleObj(value);
        this.getTemplateViewModel().idArticle(value.id);
        this.getTemplateViewModel().isShowArticleSuggestions(false);

        let closeBtn = document.querySelector("#directoryFilter [id^='user-input-close_']")

        this.caller.filterSimpleOnChange(this.idElement);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterDirectoryItem_template.ts